export const ALL_DRAFT_REQUEST = "ALL_DRAFT_REQUEST";
export const ALL_DRAFT_SUCCESS = "ALL_DRAFT_SUCCESS";
export const ALL_DRAFT_FAIL = "ALL_DRAFT_FAIL";

export const ALL_REPORT_REQUEST = "ALL_REPORT_REQUEST";
export const ALL_REPORT_SUCCESS = "ALL_REPORT_SUCCESS";
export const ALL_REPORT_FAIL = "ALL_REPORT_FAIL";
